var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart-item" }, [
    _c(
      "a",
      {
        staticClass: "thumb",
        attrs: { href: _vm.model.url, target: "_blank" }
      },
      [_c("media", { attrs: { media: _vm.media, width: "192" } })],
      1
    ),
    _c("div", { staticClass: "info" }, [
      _c("div", {
        staticClass: "name",
        domProps: { textContent: _vm._s(_vm.model.name) }
      }),
      _c("p", [
        _vm._v("\n      Количество: " + _vm._s(_vm.product.quantity)),
        _c("br"),
        _vm._v("\n      Цвет: " + _vm._s(_vm.model.color.name)),
        _c("br"),
        _vm._v("\n      Размер: " + _vm._s(_vm.size) + "\n    ")
      ]),
      _c("div", { staticClass: "prices" }, [
        _c(
          "div",
          { class: ["price price-rub", { discount: _vm.isDiscount }] },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm._f("price")(
                    _vm.price.discountPrice || _vm.price.basePrice
                  )
                ) +
                "\n      "
            )
          ]
        ),
        _vm.isDiscount
          ? _c("div", { staticClass: "old-price" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("price")(_vm.price.basePrice)) +
                  "\n      "
              )
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }